import React, { useState } from "react";
import { Button, FormFieldSet, Modal } from "../../../../../../components";
import { notesPriority } from "../../../../../../assets/data/enumData";

const ApplicantNotesModal = ({ isOpen, onChange, value, onClick, onClose, }) => {
  const [jobPost, setJobPost] = useState();
  const [priority, setPriority] = useState();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={false}
      width="max-w-3xl"
    >
      <div className="p-2">
        <h6 className="font-semibold my-4">Add Notes</h6>

        <div className="flex flex-col gap-2">
          <FormFieldSet
            type="companiesSearch"
            title="Select the Job"
            placeholder="Select Job"
            value={jobPost}
            showSearch
            onChange={(value) => setJobPost(value.uiid)}
          />

          <FormFieldSet
            type="select"
            title="Priority"
            placeholder="Select Priority"
            options={notesPriority}
            value={priority}
            onChange={(value) => setPriority(value)}
          />

          <FormFieldSet title="Note" value={value} onChange={onChange} type="textArea" rows={5} placeholder="Enter Note" />
        </div>

      </div>
      <div className="p-2">
      </div>
      <div className="flex justify-end gap-4">
        <Button title="Cancel" size="sm" variant="outlined" onClick={() => {
          setJobPost();
          setPriority();
          onClose();
        }} />
        <Button title="Apply" size="sm" onClick={() => {
          onClick(jobPost, priority)

          setJobPost();
          setPriority()
        }} />
      </div>
    </Modal>
  );
};

export default ApplicantNotesModal;
